import axios2 from "axios";
import {axios} from "./config"
import { apiURl } from '../helpers';
export class graphData extends axios{
axios;
constructor(){
    super();
    this.axios=this.axiosConfig();
}
async getRealTimeData(){
 try{
    let result=await this.axios({
        method:"get",
        url:"/homePageReailTimeData.php",
       });
        return new Promise((res,rej)=>{
        res(result.data);
        })
 }catch(e){
    if(e.response.status===401){
       this.logout();
       
    }
    else{
        return new Promise((res,rej)=>{
            rej(e);
            })
    }
   
 }
}
async getPriviousMonthComparisionData(month){
    try{
       let result=await this.axios({
           method:"get",
           url:"/homePagePriviousMonthComparison.php?month="+month,
           
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async viseData(){
    try{
       let result=await this.axios({
           method:"get",
           url:"/homePageData.php",
           
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   } 
   async getRealTimeAnalytics(){
    try{
       let result=await this.axios({
           method:"get",
           url:"analytics/monthlyCount.php",
          });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
       if(e.response.status===401){
          this.logout();
          
       }
       else{
           return new Promise((res,rej)=>{
               rej(e);
               })
       }
      
    }
   }
   async getMonthlyChartReportData(month,year){
    try{
       let result=await this.axios({
           method:"get",
           url:"monthlyChartReport/monthlyLineChart.php?month="+month+"&year="+year,
           
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async getSixMonthChartReportData(month,year){
    try{
       let result=await this.axios({
           method:"get",
           url:"monthlyChartReport/sixMonthTrend.php?month="+month+"&year="+year,
           
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async getWeeklyViseData(month){
    try{
       let result=await this.axios({
           method:"get",
           url:"monthlyChartReport/weekDays.php?week="+month,
           
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async getHourlyViseData(date,type){
    try{
       let result=await this.axios({
           method:"get",
           url:"monthlyChartReport/hourlyData.php?date="+date+"&type="+type,
           
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async getRealTimeDataFloorWise(){
    try{
       let result=await this.axios({
           method:"get",
           url:"floorViseData/reailTime.php",
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
       if(e.response.status===401){
       this.logout();
       
    }
    else{
        return new Promise((res,rej)=>{
            rej(e);
            })
    }
    }
   }
   async getTableDataFloorWise(){
    try{
       let result=await this.axios({
           method:"get",
           url:"floorViseData/pageData.php",
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async heatMapData(date){
    try{
       let result=await this.axios({
           method:"get",
           url:"/heatmap.php?date="+date,
           
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   } 
   async anprData(date,type){
    try{
       let result=await this.axios({
           method:"get",
           url:"/anpr_details.php?date="+date+"&type="+type,
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   } 
   async getFoodArea(){
    try{
       let result=await this.axios({
           method:"get",
           url:"specialArea/foodCourt.php",
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async getSpecialArea(){
    try{
       let result=await this.axios({
           method:"get",
           url:"specialArea/specialArea.php",
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async getTwoDateComparison(date1,date2){
    try{
       let result=await this.axios({
           method:"get",
           url:"analytics/twoDateComparision.php?date1="+date1+"&date2="+date2,
           
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async getdayWiseMonthlyData(month,year){
    try{
       let result=await this.axios({
           method:"get",
           url:"analytics/dayWiseMonthlyData.php?month="+month+"&year="+year,
           
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async getEscalationStackedData(){
    try{
       let result=await this.axios({
           method:"get",
           url:"escalation/realtimeDataColumChart.php",
           
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async getRealTimeDataFr(){
    try{
       let result=await this.axios({
           method:"get",
           url:"FR/realtime.php",
          });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
       if(e.response.status===401){
          this.logout();
          
       }
       else{
           return new Promise((res,rej)=>{
               rej(e);
               })
       }
      
    }
   }
   async frEmloyeeData(){
    try{
       let result=await this.axios({
           method:"get",
           url:"/FR/customerDetails.php",
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   } 
   async fashionAttribute(){
    try{
       let result=await this.axios({
           method:"get",
           url:"fashionAttributes.php",
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   } 
   async getDoubleLineChartFloorWise(){
    try{
       let result=await this.axios({
           method:"get",
           url:"floorViseData/lineChart.php",
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async getEscalationLineChartFloorWise(date){
    try{
       let result=await this.axios({
           method:"get",
           url:"escalation/lineChartFloorWise.php?date="+date,
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async getRoles(){
    try{
       let result=await this.axios({
           method:"get",
           url:"role/get.php"
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }

   async deleteRole(id){
    try{
        let result=await axios2({
            url:`${apiURl}/role/delete.php`,
            method:"post",
            data:JSON.stringify({id})
            });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async addRole(data){
    try{
       
        
       let result=await axios2({
           url:`${apiURl}/role/create.php`,
           method:"post",
           data:JSON.stringify(data)
           });
     return new Promise((res,rej)=>{
            res(result.data.data);
            })
        
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async updateRole(data){
    try{
       
        
       let result=await axios2({
           url:`${apiURl}/role/update.php`,
           method:"post",
           data:JSON.stringify(data)
           });
     return new Promise((res,rej)=>{
            res(result.data.data);
            })
        
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async getUsers(){
    try{
       let result=await this.axios({
           method:"get",
           url:"user/get.php"
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async deleteUser(id){
    try{
        let result=await axios2({
            url:`${apiURl}/user/delete.php`,
            method:"post",
            data:JSON.stringify({id})
            });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async addUser(data){
    try{
       let formData=new FormData();
       for(let key in data){
        formData.append(key,data[key]);
       }
        
       let result=await axios2({
           url:`${apiURl}/user/create.php`,
           method:"post",
           data:formData
           });
     return new Promise((res,rej)=>{
            res(result.data.data);
            })
        
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async updateUser(data){
    try{
       
        
       let result=await axios2({
           url:`${apiURl}/user/update.php`,
           method:"post",
           data:JSON.stringify(data)
           });
     return new Promise((res,rej)=>{
            res(result.data.data);
            })
        
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async getEscalationLineChartMallVise(date){
    try{
       let result=await this.axios({
           method:"get",
           url:"escalation/lineChartVehAndMallAndFoodCourt.php?date="+date,
           });
           return new Promise((res,rej)=>{
           res(result.data);
           })
    }catch(e){
        if(e.response.status===401){
            this.logout();
            
         }
         else{
             return new Promise((res,rej)=>{
                 rej(e);
                 })
         }
    }
   }
   async logout(){
    alert("please Login again")
    sessionStorage.clear();
    localStorage.clear();
   }
}
